export const versions = {
  version: "1.0.183",
  revision: "530fc3d30",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5152-g530fc3d30-dirty",
    hash: "g530fc3d30",
    distance: 5152,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5152-g530fc3d30-dirty",
    semverString: "1.0.183+5152.g530fc3d30.dirty"
  }
};
